import { FormProvider, useForm } from "react-hook-form";

import { RadioGroup } from "@synthesis/shared-ui/Radio";

import { renderRadioItems, type DrawingPlane } from "./modal-open-pdf.lib";

type DrawingPlaneReadonlyProps = {
  value?: DrawingPlane;
};

type DrawingPlaneReadonlyContentProps = {
  value: DrawingPlane;
};

const DrawingPlaneReadonlyContent = ({ value }: DrawingPlaneReadonlyContentProps) => {
  const activeItem = renderRadioItems.find((item) => item.value === value);

  const methods = useForm({
    defaultValues: {
      plane: value,
    },
  });

  if (!activeItem) {
    return null;
  }

  return (
    <FormProvider {...methods}>
      <div className="pointer-events-none">
        <RadioGroup
          name="plane"
          renderRadioGroupElements={[
            {
              ...activeItem,
              id: `drawing-plane-display-${activeItem.id}`,
            },
          ]}
          disabled
          horizontal
          gap="sm"
        />
      </div>
    </FormProvider>
  );
};

const DrawingPlaneReadonly = ({ value }: DrawingPlaneReadonlyProps) => {
  if (!value) {
    return null;
  }

  return <DrawingPlaneReadonlyContent key={value} value={value} />;
};

export default DrawingPlaneReadonly;
